import { isPlatformBrowser } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Product } from 'src/app/interfaces/product.model';
import { environment } from 'src/environments/environment';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {
  category: BehaviorSubject<String> = new BehaviorSubject('')
  query: BehaviorSubject<string> = new BehaviorSubject('')
  searchQuery: BehaviorSubject<boolean> = new BehaviorSubject(false)
  products: BehaviorSubject<any[]> = new BehaviorSubject([])
  constructor(
    private http: HttpService,
    @Inject(PLATFORM_ID) private platformID,
    ) { }


  setCategory(category:string){
    if(isPlatformBrowser(this.platformID)){
      localStorage.setItem('categorySelected', category)
      this.category.next(category)
    }
  }

  getCategory(): Observable<String>{
    if(isPlatformBrowser(this.platformID)){
      let ctg = localStorage.getItem('categorySelected') || ''
      this.category.next(ctg)
      return this.category
    }
  }



  setProducts(products:any[]){
    if(isPlatformBrowser(this.platformID)){
      this.products.next(products)
    }
  }

  getProducts(): Observable<any>{
    if(isPlatformBrowser(this.platformID)){
      return this.products
    }
  }


  getProductsWholesale(){
    return this.http.get(`wholesales/products/list/${environment.CLIENT}`)
  }

  getProductBySku(sku: string, id_store : string, wholesale:boolean) : Promise<any> {
    if(wholesale){
      let params : HttpParams = new HttpParams()
      .append('ws', 'true')
      .append('r', 'false')
      return this.http.get(`products/${sku}/detail/${id_store}`, params)
    }else{
      let params : HttpParams = new HttpParams()
      .append('ws', 'false')
      .append('r', 'true')
      return this.http.get(`products/${sku}/detail/${id_store}`, params)
    }
  }


  getTopBestSeller(id_store : string, quantity: number) : Promise<any> {
    let params : HttpParams = new HttpParams()
    .append('paginate', String(quantity))
    return this.http.get(`products/solds/${id_store}`, params)
}


  getNewArrivals(id_store : string, quantity: number) : Promise<any> {
      let params : HttpParams = new HttpParams()
      .append('paginate', String(quantity))
      return this.http.get(`products/news/${id_store}`, params)
  }


  getRelateds(id_store : string, sku: any) : Promise<any> {
    // {{url}}V2/ptoducts/relateds/{id_store}/{sku}
    // let params : HttpParams = new HttpParams()
    // .append('paginate', String(quantity))
    return this.http.get(`products/relateds/${id_store}/${sku}`)
  }


  getDetailProductProperties(id_store:string, id_product:string){
    let params : HttpParams = new HttpParams()
    .append('id_store', String(id_store))
    .append('product_sku', String(id_product))
    .append('product', String(id_product))
    return this.http.get('properties/getproduct', params)
  }
  getDetailProductPropertiesname(id_store:string, name:string){
    let params : HttpParams = new HttpParams()
    .append('id_store', String(id_store))
    .append('name', String(name))
    return this.http.get('properties/getproductname', params)
  }

  getListCategory(id_tienda: string, category:string, page:number = 1, isWholesale:boolean = false, sub:boolean, subCatg?:string) : Promise<any> {
    if(!sub){
      let params : HttpParams = new HttpParams()
      .append('page', String(page))
      .append('paginate', String(16))
      .append('ws', 'false')
      .append('r', 'true')
      return this.http.get2(`products/listCategories/${id_tienda}/${category}`, params);
    }else{
      // console.log(subCatg)
      let params : HttpParams = new HttpParams()
      .append('page', String(page))
      .append('paginate', String(16))
      .append('ws', 'false')
      .append('r', 'true')
      return this.http.get2(`products/listCategories/${id_tienda}/${category}/${subCatg}`, params);
    }
    // if(isWholesale){
    //   let params : HttpParams = new HttpParams()
    //   .append('page', String(page))
    //   .append('ws', 'true')
    //   .append('r', 'false')
  
    //   return this.http.get2(`products/listCategories/${id_tienda}/${category}`, params);
    // }else{
    //   let params : HttpParams = new HttpParams()
    //   .append('page', String(page))
    //   .append('ws', 'false')
    //   .append('r', 'true')
    //   return this.http.get2(`products/listCategories/${id_tienda}/${category}`, params);
    // }
  }

  getListTags(id_tienda: string, tag:string, page:number = 1, isWholesale:boolean = false, sub:boolean, subCatg?:string) : Promise<any> {
      let params : HttpParams = new HttpParams()
      .append('page', String(page))
      .append('paginate', String(16))
      .append('ws', 'false')
      .append('r', 'true')
      return this.http.get2(`products/listTags/${id_tienda}/${tag}`, params);
      // tags/{id_store}/detail/{tag}
  }


  
  getFullListProduct(id_store:string,page:any,paginate:any=16) {
    let params : HttpParams = new HttpParams()
    .append('paginate', String(paginate))
    .append('page', String(page))
    .append('id_store', id_store);
    return this.http.get(`products/list/${id_store}`,params)
  }

    
  getFullListProductFilter(id_store:string,data:any,page:any,paginate:any=50) {
    return this.http.post(`products/filter/${id_store}?paginate=${paginate}&page=${page}`,data)
  }


  searchProducts(page, search:string, id_store:string): Promise<any>{
    let params : HttpParams = new HttpParams()
    .append('search', String(search))
    .append('paginate', String(16))
    .append('page', String(page))
    .append('status', 'active')
    .append('id_store', id_store);
    return this.http.get('properties/searchfilter', params)
  }
  // config tamaño de reduccion para productos y banners
}
